module.exports = __webpack_public_path__ + "img/trial2-1.d33d9f69.png";